import React, { useState } from "react";
import { Button } from "semantic-ui-react";

import Prompt from "./Prompt";

function PromptButton({
  promptType,
  promptTitle,
  promptContent,
  onConfirm,
  onCancel,
  children,
  ...buttonProps
}) {
  const [showPrompt, promptIt] = useState(false);

  const cancel = () => {
    promptIt(false);
    onCancel && onCancel();
  };

  const confirm = () => {
    promptIt(false);
    onConfirm();
  };

  return (
    <>
      <Button {...buttonProps} onClick={() => promptIt(true)}>
        {children}
      </Button>
      <Prompt
        type={promptType}
        show={showPrompt}
        title={promptTitle}
        content={promptContent}
        onCancel={cancel}
        onConfirm={confirm}
      />
    </>
  );
}

export default React.memo(PromptButton);
